module.exports = __webpack_public_path__ + "img/mod_7.db684c7b.png";